// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import UsersGroups from './UsersGroups';

export default compose(
  connect(
    state => ({
      app: state.app
    }),
    dispatch => ({}),
  ),
)(UsersGroups);
